import React from "react";
import { X, Minus, Plus, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const { items, cartOpen, setCartOpen, setQty, remove, subtotal, delivery_fee, total, count } = useCart();
  const navigate = useNavigate();

  const go = () => { setCartOpen(false); navigate("/checkout"); };

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/40 z-40 transition-opacity ${cartOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={() => setCartOpen(false)}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed z-50 bg-white shadow-2xl transition-transform duration-300 ease-out
          inset-x-0 bottom-0 rounded-t-3xl md:rounded-none md:rounded-l-3xl md:inset-y-0 md:right-0 md:left-auto md:w-[420px]
          ${cartOpen ? "translate-y-0 md:translate-x-0" : "translate-y-full md:translate-y-0 md:translate-x-full"}`}
      >
        <div className="flex flex-col h-full max-h-[85vh] md:max-h-full">
          <div className="bottom-sheet-handle md:hidden mt-3" />
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <div>
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-gray-400">Your basket</div>
              <div className="font-display font-black text-xl">{count} {count === 1 ? "item" : "items"}</div>
            </div>
            <button onClick={() => setCartOpen(false)} className="rounded-full p-2 hover:bg-gray-100" data-testid="close-cart-btn">
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">
            {items.length === 0 && (
              <div className="py-16 text-center">
                <div className="text-5xl mb-4">🍜</div>
                <div className="font-display font-bold text-lg">Nothing here yet</div>
                <p className="text-sm text-gray-500 mt-1">Add dishes from the menu to get started.</p>
              </div>
            )}
            {items.map((it) => (
              <div key={it.key} className="flex gap-3" data-testid={`cart-item-${it.product_id}`}>
                <img src={it.image} alt={it.name} className="w-16 h-16 rounded-xl object-cover bg-gray-100" />
                <div className="flex-1">
                  <div className="font-bold text-sm">{it.name}</div>
                  {it.variant && <div className="text-xs text-gray-500">{it.variant}</div>}
                  <div className="text-sm font-medium mt-1">₹{it.price}</div>
                </div>
                <div className="flex flex-col items-end justify-between">
                  <button onClick={() => remove(it.key)} className="text-gray-400 hover:text-black" data-testid={`remove-${it.product_id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                  <div className="flex items-center gap-2 border border-gray-200 rounded-full px-2 py-1">
                    <button onClick={() => setQty(it.key, it.qty - 1)} data-testid={`dec-${it.product_id}`}><Minus className="w-3.5 h-3.5" /></button>
                    <span className="w-5 text-center text-sm font-bold" data-testid={`qty-${it.product_id}`}>{it.qty}</span>
                    <button onClick={() => setQty(it.key, it.qty + 1)} data-testid={`inc-${it.product_id}`}><Plus className="w-3.5 h-3.5" /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {items.length > 0 && (
            <div className="border-t border-gray-100 p-6 bg-white">
              <div className="space-y-1.5 text-sm mb-4">
                <div className="flex justify-between"><span className="text-gray-500">Subtotal</span><span>₹{subtotal}</span></div>
                <div className="flex justify-between"><span className="text-gray-500">Delivery</span><span className="text-gray-500 text-xs">Calculated at checkout</span></div>
                <div className="flex justify-between pt-2 border-t border-dashed border-gray-200 font-bold text-base">
                  <span>Subtotal</span><span data-testid="cart-total">₹{total}</span>
                </div>
              </div>
              <button
                onClick={go}
                className="w-full bg-black text-white rounded-full py-3.5 font-bold hover:bg-gray-800 active:scale-[0.99] transition"
                data-testid="cart-checkout-btn"
              >
                Checkout
              </button>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
